import React from 'react';
import './OurTeamHeroArea.css';

const OurTeamHeroArea = () => {
    return (
        <section className="ourTeam-hero-section">
            <div className="ourTeam-bgOverlay">
                <div className="container">
                    <div className="ourTeam-content">
                        <h4>Home / Our Team</h4>
                        <h1>Our Team</h1>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default OurTeamHeroArea;